import { pickBy } from 'lodash';
import { oauth } from '../utils';

export const LOAD_DIVISION_REQUEST = 'LOAD_DIVISION_REQUEST';
export const LOAD_DIVISION_SUCCESS = 'LOAD_DIVISION_SUCCESS';
export const LOAD_DIVISION_FAILURE = 'LOAD_DIVISION_FAILURE';

export const LOAD_DIVISION_ADDRESSES_REQUEST = 'LOAD_DIVISION_ADDRESSES_REQUEST';
export const LOAD_DIVISION_ADDRESSES_SUCCESS = 'LOAD_DIVISION_ADDRESSES_SUCCESS';
export const LOAD_DIVISION_ADDRESSES_FAILURE = 'LOAD_DIVISION_ADDRESSES_FAILURE';
export const LOAD_DIVISION_CONTACTS_REQUEST = 'LOAD_DIVISION_CONTACTS_REQUEST';
export const LOAD_DIVISION_CONTACTS_SUCCESS = 'LOAD_DIVISION_CONTACTS_SUCCESS';
export const LOAD_DIVISION_CONTACTS_FAILURE = 'LOAD_DIVISION_CONTACTS_FAILURE';

export const LOAD_ACCOUNT_CONTACTS_REQUEST = 'LOAD_ACCOUNT_CONTACTS_REQUEST';
export const LOAD_ACCOUNT_CONTACTS_SUCCESS = 'LOAD_ACCOUNT_CONTACTS_SUCCESS';
export const LOAD_ACCOUNT_CONTACTS_FAILURE = 'LOAD_ACCOUNT_CONTACTS_FAILURE';

export const ADD_SUPPLIER_REQUEST = 'ADD_SUPPLIER_REQUEST';
export const ADD_SUPPLIER_SUCCESS = 'ADD_SUPPLIER_SUCCESS';
export const ADD_SUPPLIER_FAILURE = 'ADD_SUPPLIER_FAILURE';

export const LOAD_SUPPLIER_REQUEST = 'LOAD_SUPPLIER_REQUEST';
export const LOAD_SUPPLIER_SUCCESS = 'LOAD_SUPPLIER_SUCCESS';
export const LOAD_SUPPLIER_FAILURE = 'LOAD_SUPPLIER_FAILURE';

export const FETCH_SUPPLIERS_SUCCESS = 'FETCH_SUPPLIERS_SUCCESS';

const createAddSupplierRequest = supplier => ({
  type: ADD_SUPPLIER_REQUEST,
  payload: {
    supplier
  }
});

const createFinalizeAddSupplier = supplier => ({
  type: ADD_SUPPLIER_SUCCESS,
  payload: {
    supplier
  }
});

const createFailedAddSupplier = supplier => ({
  type: ADD_SUPPLIER_FAILURE,
  payload: {
    supplier
  }
});

export const createAddSupplier = supplier => dispatch => {
  dispatch(createAddSupplierRequest(supplier));

  return oauth('POST', 'account', Object.assign({ company_type: 'SUPPLIER' }, supplier)).then(
    ({ json }) => dispatch(createFinalizeAddSupplier(json.account)),
    ({ json }) => dispatch(createFailedAddSupplier(supplier))
  );
};

const createLoadSupplierRequest = supplier_type => ({
  type: LOAD_SUPPLIER_REQUEST,
  payload: {
    type: supplier_type
  }
});

const createFinalizeLoadSupplier = (supplier_type, suppliers) => ({
  type: LOAD_SUPPLIER_SUCCESS,
  payload: {
    type: supplier_type,
    suppliers
  }
});

const createFailedLoadSupplier = supplier_type => ({
  type: LOAD_SUPPLIER_FAILURE,
  payload: {
    type: supplier_type
  }
});

export const createLoadSupplier = supplier_type => dispatch => {
  dispatch(createLoadSupplierRequest(supplier_type));

  const data = {
    type: supplier_type,
    'max-results': 4294967296 // big number
  };

  oauth('GET', 'supplier/toc', data).then(
    ({ json }) => dispatch(createFinalizeLoadSupplier(supplier_type, json.suppliers)),
    ({ json }) => dispatch(createFailedLoadSupplier(supplier_type))
  );
};

const createLoadDivisionRequest = supplier_type => ({
  type: LOAD_DIVISION_REQUEST,
  payload: {
    type: supplier_type
  }
});

const createFinalizeLoadDivision = (supplier_type, divisions) => ({
  type: LOAD_DIVISION_SUCCESS,
  payload: {
    type: supplier_type,
    divisions
  }
});

const createFailedLoadDivision = supplier_type => ({
  type: LOAD_DIVISION_FAILURE,
  payload: {
    type: supplier_type
  }
});

export const createLoadDivision = (supplier_type, check_supplier_active=false) => dispatch => {
  dispatch(createLoadDivisionRequest(supplier_type));

  const data = {
    type: supplier_type,
    check_supplier_active: check_supplier_active === true ? 1 : 0,
    'max-results': 4294967296 // big number
  };

  oauth('GET', 'division/toc', data, null, null, null, false).then(
    ({ json }) => dispatch(createFinalizeLoadDivision(supplier_type, json.divisions)),
    ({ json }) => dispatch(createFailedLoadDivision(supplier_type))
  );
};

const createLoadDivisionAddressesRequest = division_id => ({
  type: LOAD_DIVISION_ADDRESSES_REQUEST,
  payload: {
    division_id: division_id
  }
});

const createFinalizeLoadDivisionAddresses = (division_id, addresses) => ({
  type: LOAD_DIVISION_ADDRESSES_SUCCESS,
  payload: {
    division_id: division_id,
    addresses,
  }
});

const createFailedLoadDivisionAddresses = division_id => ({
  type: LOAD_DIVISION_ADDRESSES_FAILURE,
  payload: {
    division_id: division_id
  }
});

export const createLoadDivisionAddresses = (division_id, ship_method = false) => dispatch => {
  dispatch(createLoadDivisionAddressesRequest(division_id));

  const data = {
    parent_type: 'SUPPLIER-ACCOUNT',
    parent_id: division_id,
    ship_method: ship_method
  };

  return oauth('GET', 'address', data).then(
    ({ json }) => dispatch(createFinalizeLoadDivisionAddresses(division_id, json.addresses)),
    ({ json }) => dispatch(createFailedLoadDivisionAddresses(division_id))
  );
};

const createLoadDivisionContactsRequest = division_id => ({
  type: LOAD_DIVISION_CONTACTS_REQUEST,
  payload: {
    division_id: division_id
  }
});

const createFinalizeLoadDivisionContacts = (division_id, contacts) => ({
  type: LOAD_DIVISION_CONTACTS_SUCCESS,
  payload: {
    division_id: division_id,
    contacts
  }
});

const createFailedLoadDivisionContacts = division_id => ({
  type: LOAD_DIVISION_CONTACTS_FAILURE,
  payload: {
    division_id: division_id
  }
});

export const createLoadDivisionContacts = division_id => dispatch => {
  dispatch(createLoadDivisionContactsRequest(division_id));

  const data = {
    company_id: division_id,
    search_type: 'company-users',
    company_type: 'SUPPLIER',
    exclude_hidden: 1,
    exclude_default_company_users: 1
  };

  oauth('GET', 'user', data).then(
    ({ json }) => dispatch(createFinalizeLoadDivisionContacts(division_id, json.companyUsers)),
    ({ json }) => dispatch(createFailedLoadDivisionContacts(division_id))
  );
};

const requestLoadAccountContacts = (division_id) => ({
  type: LOAD_ACCOUNT_CONTACTS_REQUEST,
  payload: {
    division_id
  }
});

const finalizeLoadAccountContacts = (division_id, contacts) => ({
  type: LOAD_ACCOUNT_CONTACTS_SUCCESS,
  payload: {
    division_id,
    contacts
  }
});

const failedLoadAccountContacts = (division_id, error) => ({
  type: LOAD_ACCOUNT_CONTACTS_FAILURE,
  payload: {
    division_id,
    error
  }
});

export const loadAccountContacts = division_id => dispatch => {
  dispatch(requestLoadAccountContacts(division_id));
  return oauth('GET', 'contact', { parent_type: 'SUPPLIER-ACCOUNT', parent_id: division_id }).then(
    ({ json }) => dispatch(finalizeLoadAccountContacts(division_id, json.contacts)),
    ({ json }) => dispatch(failedLoadAccountContacts(division_id, json.error))
  );
};

const createFinalizeSupplierAccount = supplier_account => dispatch => {

};

export const createSupplierAccount = (company_id, company_name, company_type) => dispatch => {
  const data = {
    company_id,
    company_name,
    company_type
  };

  oauth('POST', 'account', data).then(
    ({ json }) => dispatch(createFinalizeSupplierAccount(json.account))
  );
};

const finalizeFetchSuppliers= (suppliers) => ({
  type: FETCH_SUPPLIERS_SUCCESS,
  payload: {
    suppliers
  }
});

export const createFetchSuppliers = (keyword, tag_id, account_status_id, accounts_only, benefit_id) => dispatch => {
  const data = {
    ...pickBy({
      entities_only: true,
      keyword,
      tag_id,
      account_status_id,
      benefit_id,
    }),
    accounts_only: accounts_only ? 1 : 0,
  };

  return oauth('GET', 'page/suppliers', data).then(
    ({ json }) => dispatch(finalizeFetchSuppliers(json.payload.suppliers))
  );
};

export const createFetchDivision = (division_id) => dispatch => {
  const data = {
    entities_only: true,
    division_id
  };

  return oauth('GET', 'page/suppliers', data).then(
    ({ json }) => dispatch(finalizeFetchSuppliers(json.payload.suppliers))
  );
};

export const createFetchSupplier = (supplier_id) => dispatch => {
  const data = {
    entities_only: true,
    supplier_id
  };

  oauth('GET', 'page/suppliers', data).then(
    ({ json }) => dispatch(finalizeFetchSuppliers(json.payload.suppliers))
  );
};

export const createLoadTopSuppliers = () => dispatch => {
  oauth('GET', 'supplier', { top: true }).then(
    ({ json }) => dispatch(createFinalizeLoadSupplier('ALL', json.suppliers))
  );
};

export const createFinalizeLoadSupplierAccountList = (suppliers) => ({
  type: FETCH_SUPPLIERS_SUCCESS,
  payload: {
    suppliers
  }
});
